/**
 * DIISEA Blog article — TOC, share, newsletter success, table wrappers
 */
(function () {
  if (window.DiiseaBlog && window.DiiseaBlog.__finalReady) {
    return;
  }

  var globalListenersBound = false;
  var MOBILE_MQ = "(max-width: 744px)";
  var SCROLL_OFFSET = 100;
  var lastMobile = null;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_MQ).matches;
  }

  function findBlogRoots(scope) {
    var roots = [];
    var base = scope && scope.nodeType ? scope : document;

    if (base.nodeType === 1 && base.matches && base.matches("[data-diisea-blog]")) {
      roots.push(base);
    }

    if (base.querySelectorAll) {
      toArray(base.querySelectorAll("[data-diisea-blog]")).forEach(function (node) {
        if (roots.indexOf(node) === -1) roots.push(node);
      });
    }

    return roots;
  }

  function slugifyHeading(text) {
    var raw = String(text || "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

    if (!raw) return "";

    return raw
      .replace(/[^\u4e00-\u9fff\u3400-\u4dbfa-z0-9\s-]/g, "")
      .replace(/[\s_]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  }

  function findIdInRoot(root, id) {
    if (!root || !id) return null;
    try {
      return root.querySelector('[id="' + String(id).replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"]');
    } catch (err) {
      return null;
    }
  }

  function ensureHeadingId(heading, index, usedIds, root) {
    var existing = (heading.getAttribute("id") || "").trim();
    if (
      existing &&
      !usedIds[existing] &&
      (!findIdInRoot(root, existing) || findIdInRoot(root, existing) === heading)
    ) {
      usedIds[existing] = true;
      return existing;
    }

    var slug = slugifyHeading(heading.textContent);
    if (!slug) slug = "section-" + index;

    var base = "diisea-section-" + slug + "-" + index;
    var id = base;
    var suffix = 2;

    while (usedIds[id] || (findIdInRoot(root, id) && findIdInRoot(root, id) !== heading)) {
      id = base + "-" + suffix;
      suffix += 1;
    }

    heading.id = id;
    usedIds[id] = true;
    return id;
  }

  function setTocExpanded(root, toc, toggle, expanded) {
    if (!toc) return;
    toc.classList.toggle("is-collapsed", !expanded);
    toc.classList.toggle("is-expanded", expanded);
    if (toggle) toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    root.dataset.tocExpanded = expanded ? "true" : "false";
  }

  function cellText(cell) {
    return String((cell && cell.textContent) || "")
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, "");
  }

  function tableColumnCount(table) {
    var rows = table.rows;
    var colCount = 0;
    var r;
    if (!rows) return 0;
    for (r = 0; r < rows.length; r += 1) {
      colCount = Math.max(colCount, rows[r].cells.length);
    }
    return colCount;
  }

  function stripEmptyTableColumns(table) {
    var rows = table.rows;
    if (!rows || !rows.length) return;
    if (table.querySelector("[colspan], [rowspan]")) return;

    var colCount = tableColumnCount(table);
    var r;
    var c;

    for (c = colCount - 1; c >= 0; c -= 1) {
      var empty = true;
      for (r = 0; r < rows.length; r += 1) {
        if (cellText(rows[r].cells[c])) {
          empty = false;
          break;
        }
      }
      if (!empty) continue;
      for (r = 0; r < rows.length; r += 1) {
        if (rows[r].cells[c]) rows[r].deleteCell(c);
      }
    }
  }

  function prepareContentTable(table) {
    stripEmptyTableColumns(table);
    if (tableColumnCount(table) === 2) {
      table.classList.add("diisea-blog-table-stack");
    }
  }

  function wrapContentTables(root) {
    var content = root.querySelector(".diisea-blog__content");
    if (!content) return;

    toArray(content.querySelectorAll("table")).forEach(function (table) {
      if (!table || !table.parentNode) return;

      prepareContentTable(table);

      if (table.closest(".diisea-blog__table-scroll")) return;
      if (table.closest(".c7-blog-table-wrap")) return;
      if (table.classList && table.classList.contains("c7-blog-table")) return;

      var wrap = document.createElement("div");
      wrap.className = "diisea-blog__table-scroll";
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  function hasCustomArticleToc(content) {
    if (!content) return false;
    if (content.querySelector(".c7-toc, .c7-toc-title, .c7-toc-list")) return true;

    return toArray(content.querySelectorAll("h2")).some(function (heading) {
      var text = String(heading.textContent || "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
      if (text !== "table of contents" && text !== "contents") return false;
      var next = heading.nextElementSibling;
      return !!(next && (next.matches("ol, ul, nav") || next.querySelector("ol, ul")));
    });
  }

  function scrollToHeading(id) {
    var target = document.getElementById(id);
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
    window.scrollTo({ top: top, behavior: "smooth" });
    if (history && history.pushState) {
      history.pushState(null, "", "#" + id);
    }
  }

  function initDiiseaBlogToc(root) {
    if (!root || !root.querySelector) return;

    var toc = root.querySelector("[data-diisea-blog-toc]");
    var listEl = root.querySelector("[data-diisea-toc-list]");
    var content = root.querySelector(".diisea-blog__content");
    var toggle = root.querySelector("[data-diisea-toc-toggle]");

    wrapContentTables(root);

    if (hasCustomArticleToc(content) && toc) {
      toc.hidden = true;
      toc.setAttribute("hidden", "");
      toc.classList.add("is-collapsed");
      root.dataset.tocInitialized = "true";
      return;
    }

    if (!toc || !listEl || !content) {
      root.dataset.tocInitialized = "true";
      return;
    }

    listEl.innerHTML = "";

    var headings = toArray(content.querySelectorAll("h2")).filter(function (heading) {
      if (heading.closest(".c7-toc")) return false;
      var text = (heading.textContent || "").replace(/\s+/g, " ").trim();
      if (!text.length) return false;
      if (text.toLowerCase() === "table of contents") return false;
      return true;
    });

    if (!headings.length) {
      toc.hidden = true;
      toc.setAttribute("hidden", "");
      toc.classList.add("is-collapsed");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
      root.dataset.tocInitialized = "true";
      return;
    }

    var usedIds = {};
    headings.forEach(function (heading, index) {
      var id = ensureHeadingId(heading, index + 1, usedIds, root);
      var text = (heading.textContent || "").replace(/\s+/g, " ").trim();

      var item = document.createElement("li");
      item.className = "diisea-blog__toc-item";

      var link = document.createElement("a");
      link.className = "diisea-blog__toc-link";
      link.href = "#" + id;
      link.textContent = text;

      item.appendChild(link);
      listEl.appendChild(item);
    });

    toc.hidden = false;
    toc.removeAttribute("hidden");
    setTocExpanded(root, toc, toggle, !isMobile());
    root.dataset.tocInitialized = "true";
  }

  function initShare(root) {
    var shareRoot = root.querySelector("[data-diisea-share]");
    if (!shareRoot || shareRoot.dataset.shareReady === "true") return;

    shareRoot.dataset.shareReady = "true";
    shareRoot.addEventListener("click", function (event) {
      var link = event.target.closest && event.target.closest("[data-share]");
      if (!link || !shareRoot.contains(link)) return;
      var href = link.getAttribute("href");
      if (!href || href === "#") return;
      event.preventDefault();
      window.open(href, "diisea-share", "noopener,noreferrer,width=640,height=720");
    });
  }

  function initNewsletter(root) {
    var form = root.querySelector(".diisea-blog__newsletter-form");
    if (!form || form.dataset.newsletterReady === "true") return;
    form.dataset.newsletterReady = "true";

    var success = form.querySelector(".diisea-blog__newsletter-success");
    form.addEventListener("submit", function () {
      window.setTimeout(function () {
        form.classList.add("is-submitted");
        if (success) success.hidden = false;
      }, 250);
    });
  }

  function clampProgress(value) {
    if (value < 0) return 0;
    if (value > 1) return 1;
    return value;
  }

  function updateProgressTrack(track) {
    if (!track) return;
    var bar = track.querySelector("[data-diisea-progress-bar]");
    if (!bar) return;

    var scope = track.closest(".shopify-section") || track.parentNode || document;
    var content = scope.querySelector(".diisea-blog__content");
    if (!content) {
      bar.style.transform = "scaleX(0)";
      return;
    }

    var rect = content.getBoundingClientRect();
    var viewH = window.innerHeight || 1;
    var readable = Math.max(rect.height - viewH * 0.25, 1);
    var progress = clampProgress((viewH * 0.2 - rect.top) / readable);
    bar.style.transform = "scaleX(" + progress + ")";
  }

  function updateAllProgress() {
    toArray(document.querySelectorAll("[data-diisea-progress]")).forEach(updateProgressTrack);
  }

  function initAll(scope) {
    var base = scope && scope.nodeType ? scope : document;
    findBlogRoots(base).forEach(function (root) {
      initDiiseaBlogToc(root);
      initShare(root);
      initNewsletter(root);
    });
    updateAllProgress();
    if (lastMobile === null) lastMobile = isMobile();
  }

  function syncTocOnResize() {
    var nowMobile = isMobile();
    if (lastMobile === nowMobile) return;
    lastMobile = nowMobile;

    findBlogRoots(document).forEach(function (root) {
      var toc = root.querySelector("[data-diisea-blog-toc]");
      var toggle = root.querySelector("[data-diisea-toc-toggle]");
      if (!toc || toc.hidden) return;
      setTocExpanded(root, toc, toggle, !nowMobile);
    });
  }

  function bindGlobalListeners() {
    if (globalListenersBound) return;
    globalListenersBound = true;

    document.addEventListener("click", function (event) {
      var toggle = event.target.closest && event.target.closest("[data-diisea-toc-toggle]");
      if (toggle) {
        if (!isMobile()) return;
        var rootFromToggle = toggle.closest("[data-diisea-blog]");
        if (!rootFromToggle) return;
        var toc = rootFromToggle.querySelector("[data-diisea-blog-toc]");
        if (!toc || toc.hidden) return;
        var next = toggle.getAttribute("aria-expanded") !== "true";
        setTocExpanded(rootFromToggle, toc, toggle, next);
        return;
      }

      var link = event.target.closest && event.target.closest("[data-diisea-toc-list] a[href^=\"#\"]");
      if (!link) return;
      var rootFromLink = link.closest("[data-diisea-blog]");
      if (!rootFromLink) return;

      var href = link.getAttribute("href") || "";
      var id = href.charAt(0) === "#" ? href.slice(1) : "";
      if (!id) return;

      event.preventDefault();
      scrollToHeading(id);

      if (isMobile()) {
        var tocFromLink = rootFromLink.querySelector("[data-diisea-blog-toc]");
        var toggleFromLink = rootFromLink.querySelector("[data-diisea-toc-toggle]");
        setTocExpanded(rootFromLink, tocFromLink, toggleFromLink, false);
      }
    });

    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });

    document.addEventListener("shopify:section:load", function (event) {
      var scope = event.target || document;
      findBlogRoots(scope).forEach(function (root) {
        delete root.dataset.tocInitialized;
        var share = root.querySelector("[data-diisea-share]");
        if (share) delete share.dataset.shareReady;
        var form = root.querySelector(".diisea-blog__newsletter-form");
        if (form) delete form.dataset.newsletterReady;
        initDiiseaBlogToc(root);
        initShare(root);
        initNewsletter(root);
      });
      updateAllProgress();
    });

    window.addEventListener("resize", syncTocOnResize);
    window.addEventListener("resize", updateAllProgress);
    window.addEventListener(
      "scroll",
      function () {
        if (window.DiiseaBlog && window.DiiseaBlog.__progressTick) return;
        window.DiiseaBlog = window.DiiseaBlog || {};
        window.DiiseaBlog.__progressTick = true;
        window.requestAnimationFrame(function () {
          window.DiiseaBlog.__progressTick = false;
          updateAllProgress();
        });
      },
      { passive: true }
    );
  }

  bindGlobalListeners();

  if (document.readyState !== "loading") {
    initAll(document);
  }

  window.initDiiseaBlogToc = initDiiseaBlogToc;
  window.DiiseaBlog = window.DiiseaBlog || {};
  window.DiiseaBlog.initDiiseaBlogToc = initDiiseaBlogToc;
  window.DiiseaBlog.__finalReady = true;
  window.DiiseaBlog.__tocReady = true;
  window.DiiseaBlog.__ready = true;
})();
